module.exports = __webpack_public_path__ + "img/er.3fd68dc7.svg";